import { render, staticRenderFns } from "./MarriageReportButton.vue?vue&type=template&id=0ec9a190&"
import script from "./MarriageReportButton.vue?vue&type=script&lang=js&"
export * from "./MarriageReportButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports